import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { ITaskForm } from '../../../state/ui/forms';
import TimeFormatter from '../../../helpers/TimeFormatter';
import { getTypesIds } from '../utils';
import {
    useActivityCategory,
    useObjectCategory,
    useServiceType,
} from '../../../state/app/dictionaries/index.hooks';
import { ITaskModificationDialogParams } from 'src/app/components/globalDialog/components/TaskModificationDialog/types';

export const useTaskFormInitializer = ({
    taskId,
    dates,
    route,
}: ITaskModificationDialogParams) => {
    const activityCategory = useActivityCategory();
    const serviceType = useServiceType();
    const objectCategory = useObjectCategory();

    const defaultVehicle = route
        ? {
              id: route.vehicle?.id,
              label: route.vehicle?.name || '',
          }
        : { label: '' };
    const defaultEmployee = route
        ? {
              id: route.employee?.id,
              label: route.employee?.name || '',
          }
        : { label: '' };
    const defaultRoute = route
        ? { id: route.id, label: route.name }
        : { label: '' };
    const plannedOn = moment(dates?.from).isAfter(moment(), 'days')
        ? dates?.from
        : TimeFormatter.dateToShortDateString(moment());

    const defaultActivityCategory = route ? route.activityCategoryId : '';
    const [formState, setFormState] = useState<ITaskForm>({
        notice: '',
        plannedOn: route?.plannedOn ?? plannedOn,
        noDate: false,
        plannedTimeFrom: undefined,
        plannedTimeTo: undefined,
        location: { label: '' },
        status: 1,
        vehicle: defaultVehicle,
        employee: defaultEmployee,
        activityCategory: defaultActivityCategory,
        objectCategory: '',
        serviceType: '',
        serviceClass: '',
        unitsCount: 0,
        attachments: { files: [], errors: false },
        readOnlyFiles: [],
        externalLinkages: [],
        route: defaultRoute,
    });

    useEffect(() => {
        if (!taskId) {
            if (activityCategory.length === 1) {
                const ids = getTypesIds(
                    activityCategory[0]?.id,
                    serviceType,
                    objectCategory
                );
                setFormState((prev) => ({
                    ...prev,
                    activityCategory: activityCategory[0]?.id,
                    serviceType: ids.serviceTypeId,
                    objectCategory: ids.objectCategoryId,
                }));
            }
            return;
        }
    }, [taskId, activityCategory]);

    return formState;
};
